import _ from 'lodash';
import axios from 'axios';
export const bootstrap = () => {
    /** @deprecated import lodash directly where needed */
    window._ = _;
    /** @deprecated import axios directly where needed */
    window.axios = axios;
    window.activeLoading = () => console.log('Intercepted call to activeLoading()');
    window._gridGlobalLightNavigationEnabled = false;
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
};
